import React from "react";

import useTransmissionChart from "components/pages/dashboard/transmission_analytic/chart/useTransmissionChart";
import BarChart from "components/pages/dashboard/chart/BarChart";

const TransmissionChart = ({ data, filter }) => {
  const { options, chartData } = useTransmissionChart(data, filter);

  return (
    <BarChart
      options={options}
      data={chartData}
      height={300}
      style={{ cursor: "pointer" }}
    />
  );
};

export default TransmissionChart;
